<!-- Navigation component contains the complete header structure -->
<zodi-nav></zodi-nav>
